var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zoom-image",class:{'instantiated': _vm.isInstantiated, 'zooming': _vm.isZooming},style:({
      'top': _vm.position.top,
      'left': _vm.position.left,
      'width': _vm.position.width,
      'height': _vm.position.height
  })},[_c('div',{staticClass:"image",style:({'background-image': _vm.imageToZoom})}),_c('div',{staticClass:"backdrop"})])}
var staticRenderFns = []

export { render, staticRenderFns }